import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=f3ecbcf6&scoped=true"
import script from "./Instructions.vue?vue&type=script&lang=js"
export * from "./Instructions.vue?vue&type=script&lang=js"
import style0 from "./Instructions.vue?vue&type=style&index=0&id=f3ecbcf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ecbcf6",
  null
  
)

export default component.exports